function csvEscape(value: string | number): string {
  const s = String(value ?? "");
  return /[",;\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

/** Descarga un CSV en el navegador; usa `;` como separador -estándar de Excel en es-CO- y BOM UTF-8. */
export const downloadCsv = (filename: string, rows: (string | number)[][]): void => {
  const csv = rows.map((r) => r.map(csvEscape).join(";")).join("\r\n");
  const url = URL.createObjectURL(new Blob(["﻿" + csv], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  link.click();
  // Revocar de inmediato puede invalidar el blob antes de que el navegador termine de leerlo
  // para la descarga -intermitente, más notorio bajo automatización/CDP-; se da un margen.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/**
 * Descarga un CSV que ya viene armado, tal cual: sin BOM y sin pasarlo a `;` como hace `downloadCsv`. Lo usa la
 * descarga de los envíos de un GPS, que tiene que salir exactamente como la mandó el aparato (2026-10-29).
 */
export const downloadCsvTalCual = (filename: string, contenido: string): void => {
  const url = URL.createObjectURL(new Blob([contenido], { type: "text/csv;charset=utf-8" }));
  const link = document.createElement("a");
  link.href = url;
  link.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  link.click();
  // Mismo margen que downloadCsv antes de revocar.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};
